<div class="chatbot-sidebar" 
     [class.open]="isOpen"
     [class.fullscreen]="isFullscreen"
     [style.width]="width"
     [style.top]="sidebarTop"
     [style.left]="position === 'start' ? '0' : null"
     [style.right]="position === 'end' ? '0' : null">
  
  <div class="chatbot-container">
    <!-- Header -->
    <div class="chatbot-header">
      <div class="header-content">
        <div class="header-title">
          <button 
            mat-icon-button 
            (click)="minimizeSidebar()" 
            matTooltip="Minimize sidebar"
            class="minimize-button"
            [tabindex]="isOpen ? 0 : -1">
            <mat-icon>remove</mat-icon>
          </button>
          <button 
            mat-icon-button 
            (click)="closeSidebar()" 
            matTooltip="Close sidebar"
            class="close-button"
            [tabindex]="isOpen ? 0 : -1">
            <mat-icon>close</mat-icon>
          </button>
          <mat-icon>smart_toy</mat-icon>
          <span>CultBot</span>
        </div>
        <div class="header-actions">
          <button 
            mat-icon-button 
            (click)="toggleFullscreen()" 
            matTooltip="Toggle fullscreen"
            class="fullscreen-button"
            [tabindex]="isOpen ? 0 : -1">
            <mat-icon>{{ isFullscreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
          </button>
          <button 
            mat-icon-button 
            (click)="clearChat()" 
            matTooltip="Clear chat"
            class="clear-button"
            [tabindex]="isOpen ? 0 : -1">
            <mat-icon>refresh</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- Messages Container -->
    <div class="messages-container" #messagesContainer>
      <div class="messages-content">
        @for (message of messages; track message.id) {
          <div class="message-wrapper" [class.user-message]="message.type === 'user'" [class.assistant-message]="message.type === 'assistant'">
            <div class="message-content">
              @if (message.type === 'assistant') {
                <div class="message-avatar">
                  <mat-icon>smart_toy</mat-icon>
                </div>
              }
              
              <div class="message-bubble">
                <div class="message-text" [innerHTML]="formatMessageContent(message.content)"></div>
                
                <!-- Tool call indicators -->
                @if (message.toolCalls && message.toolCalls.length > 0) {
                  <div class="tool-calls">
                    @for (toolCall of message.toolCalls; track toolCall.tool) {
                      <div class="tool-call">
                        <mat-icon class="tool-icon">build</mat-icon>
                        <span class="tool-name">{{ toolCall.display_name }}</span>
                        @if (toolCall.parameters && (toolCall.parameters | keyvalue).length > 0) {
                          <span class="tool-params">with parameters</span>
                        }
                      </div>
                    }
                  </div>
                }
                
                <div class="message-timestamp">
                  {{ message.timestamp | date:'short' }}
                </div>
              </div>
              
              @if (message.type === 'user') {
                <div class="message-avatar user-avatar">
                  <mat-icon>person</mat-icon>
                </div>
              }
            </div>
          </div>
        }
        
        @if (isLoading) {
          <div class="message-wrapper assistant-message">
            <div class="message-content">
              <div class="message-avatar">
                <mat-icon>smart_toy</mat-icon>
              </div>
              <div class="message-bubble typing">
                <div class="typing-indicator">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>

         <!-- Suggestions -->
     @if (suggestions.length > 0 && !isLoading) {
       <div class="suggestions-container">
         <mat-chip-set>
           @for (suggestion of suggestions; track suggestion) {
             <mat-chip-option (click)="useSuggestion(suggestion)" class="suggestion-chip" [tabindex]="isOpen ? 0 : -1">
               {{ suggestion }}
             </mat-chip-option>
           }
         </mat-chip-set>
       </div>
     }

    <!-- Input Area -->
    <div class="input-container">
      <div class="input-wrapper">
        <mat-form-field appearance="outline" class="message-input">
          <mat-label>Type your message...</mat-label>
          <textarea 
            #messageInput
            matInput 
            [(ngModel)]="currentMessage"
            (keydown)="onKeyPress($event)"
            [disabled]="isLoading"
            [tabindex]="isOpen ? 0 : -1"
            rows="1"
            cdkTextareaAutosize
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="4">
          </textarea>
        </mat-form-field>
        
        <button 
          mat-fab 
          (click)="sendMessage()" 
          [disabled]="!currentMessage.trim() || isLoading || powPending"
          [tabindex]="isOpen ? 0 : -1"
          class="send-button">
          <mat-icon [class.spinning]="powPending">{{ powPending ? 'autorenew' : 'send' }}</mat-icon>
        </button>
      </div>
    </div>

    <!-- Loading Bar -->
    @if (isLoading) {
      <mat-progress-bar mode="indeterminate" class="loading-bar"></mat-progress-bar>
    }
  </div>
</div>

<!-- Backdrop for mobile/overlay mode -->
<div class="chatbot-backdrop" 
     [class.visible]="isOpen && mode === 'over'"
     (click)="closeSidebar()">
</div>
